import React from "react";
import { Navigate } from "react-router-dom";
import { Routes, Route } from "react-router-dom";

import Home from "../pages/Home";
import Budget from "../pages/Budget";
import Login from "../pages/Login";
import Register from "../pages/Register";
import NotFound from "../pages/NotFound";
import TransactionHistory from "../pages/TransactionHistory";
import AddBudget from "../pages/AddBudget";
import { useAuth } from "../contexts/AuthContext";
import AddTransaction from "../pages/AddTransaction";
import Calendar from "../pages/Calendar";
import About from "../pages/About";
import Dashboard from "../pages/Dashboard";

const Router = () => {
  const { currentUser } = useAuth();
  return (
    <Routes>
      <Route
        path="/"
        element={currentUser ? <Navigate to="dashboard" replace={true} /> : <Home />}
      />

      <Route path="/about" exact element={<About />} />

      <Route
        path="dashboard"
        element={currentUser ? <Dashboard /> : <Navigate to="/" replace={true} />}
      />

      <Route
        path="budget"
        element={currentUser ? <Budget /> : <Navigate to="/login" replace={true} />}
      />

      <Route
        path="/budget/add"
        element={
          currentUser ? (
            <AddBudget to="/budget/add" replace={true} />
          ) : (
            <Navigate to="/login" replace={true} />
          )
        }
      />

      <Route
        path="/budget/edit/:id"
        element={
          currentUser ? (
            <AddBudget to="/budget/edit/:id" replace={true} />
          ) : (
            <Navigate to="/login" replace={true} />
          )
        }
      />

      <Route
        path="login"
        element={
          currentUser ? (
            <Navigate to="/transactions" replace={true} />
          ) : (
            <Login />
          )
        }
      />
      <Route
        path="register"
        element={
          currentUser ? (
            <Navigate to="/transactions" replace={true} />
          ) : (
            <Register />
          )
        }
      />

      <Route
        path="transactions"
        element={
          currentUser ? (
            <TransactionHistory to="/transactions" replace={true} />
          ) : (
            <Navigate to="/login" replace={true} />
          )
        }
      />

      <Route
        path="/transaction/add"
        element={
          currentUser ? (
            <AddTransaction to="/transaction/add" replace={true} />
          ) : (
            <Navigate to="/login" replace={true} />
          )
        }
      />

      <Route
        path="/transaction/edit/:id"
        element={
          currentUser ? (
            <AddTransaction to="/transaction/edit/:id" replace={true} />
          ) : (
            <Navigate to="/login" replace={true} />
          )
        }
      />

      <Route
        path="calendar"
        element={
          currentUser ? (
            <Calendar to="/calendar" replace={true} />
          ) : (
            <Navigate to="/login" replace={true} />
          )
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Router;
